import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    padding: 5px;
    background: rgb(64, 157, 226);
    background: linear-gradient(0deg, rgba(64, 157, 226, 1) 0%, rgba(48, 124, 191, 1) 100%);
    border-radius: 0 30px 0 0;
    grid-area: level;
    color: ${color.grayscale[1000]};
  `;
});

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[1000]};
    font-size: 1.125rem;
    font-weight: ${type.weight.regular};
    margin-left: 15px;

  `;
});

const Level = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    width: 40px;
    margin: 0 auto;
    font-size: 3.125rem;
    text-align: center;
    color: ${color.grayscale[1000]};
    margin-top: -5px;
  `;
});

const Days = styled.div`
  text-align: center;
`;

interface LevelsWidgetProps {
  currentStep: number;
}

const LevelsWidget: FC<LevelsWidgetProps> = ({ currentStep }) => {
  const level = Math.floor(currentStep / 5) + 1;

  const stepOutOfFive = (currentStep - 1) % 5;

  let daysToNextLevel = 5 - stepOutOfFive;

  if (daysToNextLevel === 0) {
    daysToNextLevel = 5;
  }

  let daysString = 'days';
  if (daysToNextLevel === 1) {
    daysString = 'day';
  }

  const daysToNextLevelText = level < 7 ? daysToNextLevel + ' more ' + daysString + ' to level ' + (level + 1) : '';
  return (
    <Container>
      <Title>Level</Title>
      <Level>{level}</Level>
      <Days>{daysToNextLevelText}</Days>
    </Container>
  );
};

export default LevelsWidget;
